import { capitalize } from '@as-react/common-utils';
const defaultPaddingsMap = {
    none: '0',
    xs: '2',
    sm: '4',
    md: '6',
    lg: '8',
    gutter: '4',
};
const directionToLogicalPropertyMap = {
    top: 'paddingBlockStart',
    bottom: 'paddingBlockEnd',
    left: 'paddingInlineStart',
    right: 'paddingInlineEnd',
};
export const getBoxPropsFromAEMPaddings = (paddings = {}, map = defaultPaddingsMap) => {
    const paddingDirections = Object.keys(paddings);
    return Object.values(paddings).reduce((prevValue, curValue, index) => {
        if (!curValue) {
            return prevValue;
        }
        const direction = paddingDirections[index];
        if (!direction) {
            return prevValue;
        }
        const logicalProperty = directionToLogicalPropertyMap[direction] || `padding${capitalize(direction)}`;
        const value = map[curValue];
        if (!value) {
            return prevValue;
        }
        return Object.assign(Object.assign({}, prevValue), { [logicalProperty]: value });
    }, {});
};
